<template>
  <div class="sub-plan-card">
    <div class="card-top" v-if="!admin">
      <button @click="turnToEditMode" v-if="!editMode" class="btn-icon" title="Edytuj">
        <img src="@/assets/icons/pencil-square.svg" alt="edytuj">
      </button>
      <button @click="deleteSubPlan" class="btn-icon btn-danger" title="Usuń">
        <img src="@/assets/icons/trash.svg" alt="usuń">
      </button>
    </div>

    <template v-if="!editMode">
      <h3 class="plan-title">{{ name }}</h3>

      <div class="plan-rows">
        <div class="plan-row">
          <span class="label">Opłata abonamentowa</span>
          <span class="value">{{ subscriptionM }} zł / miesiąc</span>
        </div>
        <div class="plan-row">
          <span class="label">Dodatkowy przypisany użytkownik</span>
          <span class="value">{{ additionalUserM }} zł / miesiąc</span>
        </div>
        <div class="plan-row">
          <span class="label">Dodatkowy SMS</span>
          <span class="value">{{ Math.floor(additionalSMS) }} zł i {{ additionalSMS * 100 % 100 }} gr / SMS</span>
        </div>
        <div class="plan-row">
          <span class="label">Darmowi użytkownicy</span>
          <span class="value">{{ freeUsers }}</span>
        </div>
        <div class="plan-row">
          <span class="label">Darmowe SMS-y</span>
          <span class="value">{{ freeSMS }}</span>
        </div>
        <div class="plan-row">
          <span class="label">Czas trwania</span>
          <span class="value">{{ period }} mies.</span>
        </div>
      </div>

      <button
          v-if="admin"
          @click="() => $router.push({ path: `${$route.path}`, query: { subId: id } })"
          class="btn-primary full"
      >
        Wybieram
      </button>
    </template>

    <form @submit.prevent="editSubPlan" v-else class="edit-form">
      <label for="name">Nazwa planu</label>
      <input type="text" id="name" v-model="editSubData.name" name="name" required>

      <label for="subscription">Opłata abonamentowa (na miesiąc)</label>
      <input type="number" step="0.01" v-model="editSubData.subscriptionM" id="subscription" name="subscription" required>

      <label for="additionalUser">Opłata za dodatkowego użytkownika (na miesiąc)</label>
      <input type="number" step="0.01" v-model="editSubData.additionalUserM" id="additionalUser" name="additionalUser" required>

      <label for="additionalSMS">Opłata za wysłanie SMS-a (w zł)</label>
      <input type="number" step="0.01" v-model="editSubData.additionalSMS" id="additionalSMS" name="additionalSMS" required>

      <label for="freeUsers">Ilość darmowych użytkowników</label>
      <input type="number" v-model="editSubData.freeUsers" id="freeUsers" name="freeUsers" required>

      <label for="freeSMS">Ilość darmowych SMS-ów</label>
      <input type="number" v-model="editSubData.freeSMS" id="freeSMS" name="freeSMS" required>

      <label for="period">Czas trwania subskrypcji (miesiące)</label>
      <input type="number" v-model="editSubData.period" id="period" name="period" required>

      <div class="form-actions">
        <button type="button" class="btn-outline" @click="editMode = false">Anuluj</button>
        <button type="submit" class="btn-green">Zapisz zmiany</button>
      </div>
    </form>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import axios from 'axios';
import { useAppStore } from '@/stores/app';

export default {
  name: 'SubPlanCard',
  setup() {
    return {
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      editMode: false,
      editSubData: {
        id: '',
        name: '',
        subscriptionM: '',
        additionalUserM: '',
        additionalSMS: '',
        freeUsers: '',
        freeSMS: '',
        period: '',
      },
    };
  },
  props: ['id', 'name', 'subscriptionM', 'additionalUserM', 'additionalSMS', 'freeUsers', 'freeSMS', 'period', 'admin'],
  methods: {
    turnToEditMode() {
      this.editMode = true;
      this.editSubData.id = this.id;
      this.editSubData.name = this.name;
      this.editSubData.subscriptionM = this.subscriptionM;
      this.editSubData.additionalUserM = this.additionalUserM;
      this.editSubData.additionalSMS = this.additionalSMS;
      this.editSubData.freeUsers = this.freeUsers;
      this.editSubData.freeSMS = this.freeSMS;
      this.editSubData.period = this.period;
    },
    editSubPlan() {
      axios.post('/Subscription', this.editSubData, authHeader()).then(() => {
        this.appStore.setIsSuccess('Pomyślnie zaktualizowano plan');
        this.editMode = false;
        this.$emit('refreshSubscriptions');
      }).catch(() => {});
    },
    deleteSubPlan() {
      const question = prompt('Czy na pewno? Wpisz "tak", jeśli tak.');
      if (question == 'tak') {
        axios.delete(`/Subscription/${this.id}`, authHeader()).then(() => {
          this.appStore.setIsSuccess('Pomyślnie usunięto plan');
          this.$emit('refreshSubscriptions');
        }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sub-plan-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  width: 100%;
  max-width: 320px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: box-shadow 0.2s, border-color 0.2s;
}

.sub-plan-card:hover {
  border-color: #10b981;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.card-top {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.plan-title {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
  font-weight: 700;
  text-align: center;
}

.plan-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.plan-row {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.plan-row .label {
  color: #6b7280;
  font-size: 1.25rem;
}

.plan-row .value {
  color: #1f2937;
  font-size: 1.45rem;
  font-weight: 700;
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edit-form label {
  font-size: 1.35rem;
  color: #374151;
  font-weight: 600;
}

.edit-form input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 1.4rem;
  outline: none;
  width: 100%;
  box-sizing: border-box;
}

.edit-form input:focus {
  border-color: #10b981;
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 6px;
  flex-wrap: wrap;
}

.full {
  width: 100%;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 10px 14px;
  border-radius: 8px;
  border: none;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.35rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.btn-icon img {
  width: 20px;
  height: 20px;
}

.btn-icon:hover {
  background-color: #f3f4f6;
}

.btn-danger:hover {
  background-color: #fee2e2;
}
</style>